// components/PreEmployment/StatusSelector.tsx

import React from 'react';
import type { StatusSelectorProps } from '../../../types/preEmployment.types';

const StatusSelector: React.FC<StatusSelectorProps> = ({
  statusOptions,
  selectedStatus,
  onStatusSelect,
}) => {
  return (
    <div className="p-6 md:p-8">
      <h3 className="text-xl font-semibold text-gray-800 mb-6">
        Veuillez sélectionner le statut médical du candidat :
      </h3>

      <div className="space-y-4">
        {statusOptions.map((option) => (
          <div
            key={option.id}
            className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
              selectedStatus === option.id
                ? "border-blue-500 bg-blue-50 shadow-md"
                : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
            }`}
            onClick={() => onStatusSelect(option.id)}
          >
            <div className="flex items-start gap-3">
              <div className="mt-1">
                <div
                  className={`w-4 h-4 rounded-full border-2 ${
                    selectedStatus === option.id
                      ? "border-blue-500 bg-blue-500"
                      : "border-gray-300"
                  }`}
                >
                  {selectedStatus === option.id && (
                    <div className="w-full h-full rounded-full bg-white scale-50"></div>
                  )}
                </div>
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-gray-800 mb-2">
                  {option.label}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {option.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusSelector;